/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function PublishStatusShareLink({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#PublishStatusShareLink_svg__a)"><rect width={14} height={12} x={1} y={2} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} rx={2} /><path fill="currentColor" d="M10.096 6.9a.53.53 0 0 0 0-.8.67.67 0 0 0-.883 0l-3.309 3a.53.53 0 0 0 0 .8.67.67 0 0 0 .883 0z" /><path fill="currentColor" d="M5.96 6.85a.53.53 0 0 1 0 .8l-.828.75a1.455 1.455 0 0 0 0 2.2c.67.608 1.757.608 2.427 0l.827-.75a.67.67 0 0 1 .882 0 .53.53 0 0 1 0 .8l-.827.75c-1.157 1.05-3.034 1.05-4.191 0s-1.157-2.75 0-3.8l.827-.75a.67.67 0 0 1 .883 0M10.04 8.35a.53.53 0 0 0 0 .8.67.67 0 0 0 .883 0l.827-.75c1.157-1.05 1.157-2.75 0-3.8s-3.034-1.05-4.191 0l-.827.75a.53.53 0 0 0 0 .8.67.67 0 0 0 .882 0l.827-.75c.67-.608 1.757-.608 2.427 0 .67.607.67 1.592 0 2.2z" /></g><defs><clipPath id="PublishStatusShareLink_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;